module.exports = "<div class=\"global-message\" [@fadeInOut]=\"display\">\n  <span class=\"gm-icon pr-2\"><i class=\"icon-ok\"></i></span>\n  <span class=\"gm-message\">{{message.message}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/global/global-message/global-message.component.html
// module id = ./client/app/global/global-message/global-message.component.html
// module chunks = main